import * as React from 'react';
import {Link, HeadFC, PageProps} from 'gatsby';

const NotFoundPage: React.FC<PageProps> = () => {
  return (
    <section className="vl-region">
      <div className="vl-layout">
        <div className="vl-grid vl-grid--is-stacked">
          <div className="vl-col--12-12 vl-col--12-12--m vl-col--12-12--s">
            <div className="vl-typography">
              <p>De opgevraagde pagina kon niet gevonden worden.</p>
              <p>Ga terug naar <Link to="/">Start</Link></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFoundPage;

export const Head: HeadFC = () => <title>Not found</title>;
